import { PerfilComponent } from "./perfil/perfil.component";
import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";


const routes: Routes = [
      {
        path: '',
        children: [
          {
            path: 'perfil',
            component: PerfilComponent,
            data: {
              title: "Perfil",
              breadcrumb: "Perfil"
            }
          }
        ]
      }
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PerfilRoutingModule {}